import React from "react"

const Logo = (props) => (
  <svg viewBox="0 0 512 512" width={26} height={26} {...props}>
    <path
      d="M385.746.015H126.244L0 172.027l255.697 339.959L512 172.042 385.746.015zm-20.244 39.968l82.135 111.913h-92.741L316.283 39.983h49.219zm-130.888 0h39.388l38.613 111.913H197.472l37.142-111.913zm-88.126 0H192.5l-37.14 111.913H64.353l82.135-111.913zM64.935 191.865h89.692l53.198 189.977-142.89-189.977zm190.669 212.383l-59.472-212.384h118.251l-58.779 212.384zm47.391-21.386l52.861-190.997h91.14L302.995 382.862z"
      data-original="#000000"
      className="prefix__active-path"
      data-old_color="#000000"
      fill="#AEAEAE"
    />
  </svg>
)

export default Logo
